import { downloadPdfConstants } from '../constants/actionTypes'

export const startedPdfDownload = () => ({
  type: downloadPdfConstants.STARTED_DOWNLOAD,
})

export const finishedPdfDownload = () => ({
  type: downloadPdfConstants.FINISHED_DOWNLOAD,
})
